(function () {
    'use strict';

    angular.module('app.controllers')
        .controller('UniqueAudienceCtrl', UniqueAudienceCtrl)
    ;

    /* @ngInject */
    function UniqueAudienceCtrl(DataFactory, $rootScope) {

        var vm = this;

        DataFactory.getTableData('ua-vs-duration').then(function (allData) {

            var uaVsDuration = {},
                source = {};

            angular.forEach(allData.rows, function (row) {

                var month = row.values[0];
                var site = row.values[1];

                if (uaVsDuration[month] === undefined) {
                    uaVsDuration[month] = [];

                    if ($rootScope.retroMonths.indexOf(month) !== -1) {
                        source[month] = 'Digital Ratings (Monthly) ' + month + ' People 18+ only. *YouTube duration reporting is sourced from the IAB Video Report (' + month + ')';
                    } else {
                        source[month] = 'Digital Content Ratings, Text, ' + month + ', People 2+, Monthly Total. *YouTube reporting is sourced from DCR Monthly Total Video';
                    }
                }

                var data = {
                    Category: site,
                    'Unique Audience (000s)': row.values[2],
                    'Time per person (hh:mm)': hoursFromTime(row.values[3]),
                    time: row.values[3] // used for chart labels
                };

                uaVsDuration[month].push(data);
            });

            vm.uaVsDuration = uaVsDuration;
            vm.source = source;
        });
    }

    function stringToDate(str) {
        var bits = str.split(':');

        if (bits.length !== 3) {
            console.log('stringToDate: not 3 parts');
            return null;
        }

        return new Date(2018, 0, 1, parseInt(bits[0], 10), parseInt(bits[1], 10), parseInt(bits[2], 10));
    }

    function hoursFromTime(time) {
        var bits = time.split(':');
        return parseInt(bits[0], 10) + parseInt(bits[1], 10)/60 + parseInt(bits[2], 10)/3600;
    }

})();
